import * as React from 'react';
import { Card, type CardProps } from 'components/ui/card';

export const AuthCard = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => <Card ref={ref} className={className} {...props} />,
);

AuthCard.displayName = 'AuthCard';
